import { render, staticRenderFns } from "./dealeven.vue?vue&type=template&id=298bfafa&scoped=true&"
import script from "./dealeven.vue?vue&type=script&lang=js&"
export * from "./dealeven.vue?vue&type=script&lang=js&"
import style0 from "./dealeven.vue?vue&type=style&index=0&id=298bfafa&lang=less&scoped=true&"
import style1 from "./dealeven.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298bfafa",
  null
  
)

export default component.exports